<template>
  <div class="brand-reviews">
    <div class="centered">
        <router-link :to="{ name: 'BrandReviewCreator' }" class="button centered">Добавить отзыв</router-link>
      </div>
    <draggable class="columns is-multiline mt-10 reviews-columns" v-model="brandReviewsObject">
      <BrandReviewItem 
        v-for="review in brandReviews" 
        :key="review.id" 
        :review="review"
        class="column is-half"
      />
    </draggable>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import deepcopy from 'deepcopy'
import BrandReviewItem from 'components/BrandHistory/BrandReviewItem'

export default {
  name: 'BrandReviews',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['brandReviews']),
    brandReviewsObject: {
      get () { return deepcopy(this.brandReviews) },
      set (value) {
        const valueCopy = deepcopy(value)
        for (let i = 0; i < valueCopy.length; i++) {
          valueCopy[i].order = i
        }
        this.updateBrandReviewsOrder(valueCopy)
      }
    }
  },
  methods: {
    ...mapActions(['getBrandReviews', 'updateBrandReviewsOrder'])
  },
  created () {
    this.getBrandReviews()
  },
  components: { BrandReviewItem, draggable }
}
</script>
<style>
.reviews-columns {
  max-width: 1280px;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// BrandReviews.vue?5b338019